import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App.tsx";
import { initVersionCheck } from "./lib/versionCheck";

// 開頁即檢查有冇新版本，有就自動 reload（見 src/lib/versionCheck.ts）
initVersionCheck();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
